import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class NonceService {
    public nonce: string = "";

    constructor(private readonly http: HttpClient) { }

    async fetchNonce(): Promise<void> {
        this.nonce = await firstValueFrom(this.http.get<string>(environment.api_uri + 'nonce'));
    }
}